export default {
    defaultErrorMessage :function(){
        return {
            required: "Zorunlu alan",
            email: "Lütfen geçerli bir e-posta adresi giriniz.",
            url: "Lütfen geçerli bir url giriniz.",
            date: "Lütfen geçerli bir tarih formatı giriniz.",
            number: "Lütfen rakam giriniz.",
            equalTo: "Lütfen şifrelerin aynı olduğundan emin olunuz.",
            maxlength: jQuery.validator.format("Lütfen {0} karakterden daha az giriniz."),
            minlength: jQuery.validator.format("Lütfen {0} karakterden daha fazla giriniz."),
            rangelength: jQuery.validator.format("Lütfen minimum {0} maksimum {1} karakter giriniz."),
            max: jQuery.validator.format("Lütfen maksimum {0} olacak şekilde giriniz."),
            min: jQuery.validator.format("Lütfen minimum {0} olacak şekilde giriniz."),
            birthdate : jQuery.validator.format("Lütfen doğum tarihinizi doğru bir şekilde giriniz."),
            tcno: jQuery.validator.format("Lütfen geçerli bir TC kimlik numarası giriniz."),
            cardowner: jQuery.validator.format("Lütfen kart sahibinin ad soyad bilgisini giriniz"),
            cardmonth: jQuery.validator.format("Lütfen kartınıza ait ay bilgisini giriniz."),
            cardyear: jQuery.validator.format("Lütfen kartınıza ait yıl bilgisini giriniz.")
        }
    } ,
    validateForm : function (formId) {
        this.initValidations()
        var form = $('#'+formId);

        //Todo: Weird syntax error lenght -> length
        for(var i = 0; i < $('[name ="tcValidation"]').lenght; i++){
            $($('[name ="tcValidation"]')[i]).mask('00000000000');
        }

        $('[name ="tcValidation"]').mask('00000000000');
        $('[name ="phoneNumberValidation"]').mask('(000) 000-0000');
        $('[name ="mobilePhoneNumberValidation"]').mask('(000) 000-0000');
        $('[name ="faxNumberValidation"]').mask('(000) 000-0000');
        $('[name ="taxNoVal"]').mask('0000000000');


        // card valid
        $('[name ="cardNoValidation"]').mask('0000 0000 0000 0000');
        $('[name ="cvcValidation"]').mask('000');
        $('[name ="cardYearValidation"]').mask('00');
        $('[name ="cardMonthValidation"]').mask('00');

        form.validate({
            ignore: ':not(select:hidden, input:visible, textarea:visible)',
            onkeyup: function(element, event) {
                var t = this;
                var excludedKeys = [
                    16, 17, 18, 20, 35, 36, 37,
                    38, 39, 40, 45, 144, 225
                ];
                if (event.which === 9 && t.elementValue(element) === "" || $.inArray(event.keyCode, excludedKeys) !== -1) {
                    return;
                } else if (element.name in t.submitted || element.name in t.invalid) {
                    t.element(element);
                }
                //TODO: Investigate suspicious unnecessary setTimeout usage.
                // setTimeout(function() {
                //     var excludedKeys = [
                //         16, 17, 18, 20, 35, 36, 37,
                //         38, 39, 40, 45, 144, 225
                //     ];
                //     if (event.which === 9 && t.elementValue(element) === "" || $.inArray(event.keyCode, excludedKeys) !== -1) {
                //         return;
                //     } else if (element.name in t.submitted || element.name in t.invalid) {
                //         t.element(element);
                //     }
                //     console.log("called");
                // }, 2000);  // 2-second delay
            },
            rules: {
                imageValidation : {
                    required: true,
                    imageValidate: true
                },
                nameValidation: {
                    required: true,
                    minlength:2
                },
                fullNameValidation: {
                    required: true,
                    minlength:2
                },
                genderValidation: {
                    required: true,
                },
                cabinNumber: {
                    required: true,
                },
                lastNameValidation: {
                    required: true,
                    minlength:2
                },
                birthdateValidation: {
                    required: true,
                    birthdate: true,
                },
                tcValidation: {
                    required: function(element) {
                        return $($(element).parent().parent().parent().parent().parent().parent().children(".isTurkishCitizen")[0]).is(':checked')
                    },
                    tcvalidation: function(element) {
                        return $($(element).parent().parent().parent().parent().parent().parent().children(".isTurkishCitizen")[0]).is(':checked')
                    }
                },
                passportValidation: {
                    required: function(element) {
                        return !$($(element).parent().parent().parent().parent().parent().parent().children(".isTurkishCitizen")[0]).is(':checked')
                    },
                },
                passportType: {
                    required: function(element) {
                        return false;
                    },
                },
                passportGiveDate: {
                    required: function(element) {
                        return !$($(element).parent().parent().parent().parent().parent().parent().children(".isTurkishCitizen")[0]).is(':checked')
                    },
                },
                passportExpDate: {
                    required: function(element) {
                        return !$($(element).parent().parent().parent().parent().parent().parent().children(".isTurkishCitizen")[0]).is(':checked')
                    },
                },
                passportPlace: {
                    required: function(element) {
                        return !$($(element).parent().parent().parent().parent().parent().parent().children(".isTurkishCitizen")[0]).is(':checked')
                    },
                },
                phoneNumberValidation: {
                    required: true,
                    minlength: 14,
                    maxlength: 14
                },
                faxNumberValidation: {
                    required: true,
                    minlength: 14,
                    maxlength: 14
                },
                mobilePhoneNumberValidation: {
                    required: true,
                    minlength: 14,
                    maxlength: 14
                },
                citizenshipValidation: {
                    required: true,
                },
                educationStatusValidation: {
                    required: true,
                },
                professionValidation: {
                    required: true,
                },
                bloodTypeValidation: {
                    required: true
                },
                emailValidation: {
                    required: true,
                    email:true
                },
                provinceValidation: {
                    required: true
                },
                districtValidation: {
                    required: true
                },
                cardOwnerValidation: {
                    required: true,
                    cardowner: true
                },
                cardNoValidation:{
                    required: true,
                    minlength: 19,
                    maxlength: 19
                },
                cardMonthValidation: {
                    required: true,
                    cardmonth:true
                },
                cardYearValidation: {
                    required: true,
                    cardyear:true,
                    minlength: 2,
                    maxlength: 2
                },
                cvcValidation: {
                    required: true,
                    minlength: 3,
                    maxlength: 3
                },
                agencyName: {
                    required: true,
                },
                cruiseRoomRoomNumber: {
                    required: true,
                },
                cruiseRoomDeck: {
                    required: true,
                },
                cruiseRoomRoom: {
                    required: true,
                },
                roomName: {
                    required: true,
                },
                roomDescription: {
                    required: true,
                },
                roomSpace: {
                    required: true,
                },
                roomAmeties: {
                    required: true,
                },
                roomMaxGuestCount: {
                    required: true,
                },
                roomMaxAdultCount: {
                    required: true,
                },
                roomCabinType: {
                    required: true,
                },
                cruiseName: {
                    required: true,
                },
                cruiseDescription: {
                    required: true,
                },
                cruiseAge: {
                    required: true,
                },
                cruiseTonaj: {
                    required: true,
                },
                cruiseLong: {
                    required: true,
                },
                cruiseBeam: {
                    required: true,
                },
                cruiseSpeed: {
                    required: true,
                },
                cruiseGuestCapacity: {
                    required: true,
                },
                cruiseTotalStaff: {
                    required: true,
                },
                portName: {
                    required: true,
                },
                portCode: {
                    required: true,
                },
                portDescription: {
                    required: true,
                },
                portImage: {
                    required: true,
                },
                priceCruise: {
                    required: true,
                },
                priceName: {
                    required: true,
                },
                sailCruise: {
                    required: true,
                },
                sailTour: {
                    required: true,
                },
                sailPricing: {
                    required: true,
                },
                sailRouteQuee: {
                    required: true,
                },
                sailRoutePortingTime: {
                    required: true,
                },
                sailRouteArrival: {
                    required: true,
                },
                sailRouteDeparture: {
                    required: true,
                },
                sailRoutePort: {
                    required: true,
                },
                seaTourName: {
                    required: true,
                },
                seaTourCode: {
                    required: true,
                },
                seaTourVisa: {
                    required: true,
                },
                seaTourImageName: {
                    required: true,
                },
                cruiseDeckName: {
                    required: true,
                },
                cruiseDeckOrder: {
                    required: true,
                },
                cruiseDeckImage: {
                    required: true,
                }
            },
            messages: {
                nameValidation: {
                    required: "Zorunlu Alan",
                    minlength: "Lütfen adınızı doğru şekilde girdiğinize emin olun"
                },
                lastNameValidation: {
                    required: "Zorunlu Alan",
                    minlength: "Lütfen soyadınızı doğru şekilde girdiğinize emin olun"
                },
                birthdateValidation: {
                    required: "Zorunlu Alan",
                    birthdate: "Lütfen doğum tarihinizi doğru şekilde girdiğinize emin olun"
                },
                tcValidation: {
                    required: "Zorunlu Alan",
                    tcvalidation: "Lütfen TC numaranızı doğru şekilde girdiğinize emin olun"
                },
                cabinNumber: {
                    required: "Zorunlu Alan",
                },
                genderValidation: {
                    required: "Zorunlu Alan",
                },
                passportValidation: {
                    required: "Zorunlu Alan",
                    passportValidation: "Lütfen Pasaport numaranızı doğru şekilde girdiğinize emin olun"
                },
                passportPlace: {
                    required: "Zorunlu Alan",
                },
                passportExpDate: {
                    required: "Zorunlu Alan",
                },
                passportGiveDate: {
                    required: "Zorunlu Alan",
                },
                passportType: {
                    required: "Zorunlu Alan",
                },
                phoneNumberValidation: {
                    required: "Zorunlu Alan",
                    minlength: "Lütfen geçerli bir telefon numarası girin",
                    maxlength: "Lütfen geçerli bir telefon numarası girin"
                },
                faxNumberValidation: {
                    required: "Zorunlu Alan",
                    minlength: "Lütfen geçerli bir telefon numarası girin",
                    maxlength: "Lütfen geçerli bir telefon numarası girin"
                },
                mobilePhoneNumberValidation: {
                    required: "Zorunlu Alan",
                    minlength: "Lütfen geçerli bir telefon numarası girin",
                    maxlength: "Lütfen geçerli bir telefon numarası girin"
                },
                citizenshipValidation: {
                    required: "Zorunlu Alan",
                },
                professionValidation: {
                    required: "Zorunlu Alan",
                },
                bloodTypeValidation: {
                    required: "Zorunlu Alan",
                },
                educationStatusValidation: {
                    required: "Zorunlu Alan",
                },
                emailValidation: {
                    required: "Zorunlu Alan",
                    email:"Lütfen geçerli bir e-posta adresi girdiğinize emin olun"
                },
                provinceValidation: {
                    required: "Zorunlu Alan",
                },
                districtValidation: {
                    required: "Zorunlu Alan",
                },
                cardOwnerValidation: {
                    required: "Zorunlu Alan",
                    cardowner: "Lütfen ad soyad bilginizi doğru girdiğinizden emin olunuz"
                },
                cardNoValidation: {
                    required: "Zorunlu Alan",
                    minlength: "Lütfen geçerli bir kart numarası girin",
                    maxlength: "Lütfen geçerli bir kart numarası girin"
                },
                cardMonthValidation: {
                    required: "*",
                    cardmonth:"*"
                },
                cardYearValidation: {
                    required: "*",
                    cardyear:"*",
                    minlength: "*",
                    maxlength: "*"
                },
                cvcValidation: {
                    required: "Zorunlu Alan",
                    minlength: "Lütfen geçerli bir cvc numarası girin",
                    maxlength: "Lütfen geçerli bir cvc numarası girin"
                },
                agencyName: {
                    required: "Zorunlu Alan",
                },
                cruiseRoomRoom: {
                    required: "Zorunlu Alan",
                },
                cruiseRoomDeck: {
                    required: "Zorunlu Alan",
                },
                cruiseRoomRoomNumber: {
                    required: "Zorunlu Alan",
                },
                portName: {
                    required: "Zorunlu Alan",
                },
                portCode: {
                    required: "Zorunlu Alan",
                },
                portDescription: {
                    required: "Zorunlu Alan",
                },
                portImage: {
                    required: "Zorunlu Alan",
                },
                seaTourName: {
                    required: "Zorunlu Alan",
                },
                seaTourCode: {
                    required: "Zorunlu Alan",
                },
                seaTourVisa: {
                    required: "Zorunlu Alan",
                },
                seaTourImageName: {
                    required: "Zorunlu Alan",
                },
                cruiseName: {
                    required: "Zorunlu Alan",
                },
                cruiseDescription: {
                    required: "Zorunlu Alan",
                },
                cruiseAge: {
                    required: "Zorunlu Alan",
                },
                cruiseTonaj: {
                    required: "Zorunlu Alan",
                },
                cruiseLong: {
                    required: "Zorunlu Alan",
                },
                cruiseBeam: {
                    required: "Zorunlu Alan",
                },
                cruiseGuestCapacity: {
                    required: "Zorunlu Alan",
                },
                cruiseTotalStaff: {
                    required: "Zorunlu Alan",
                },
                cruiseSpeed: {
                    required: "Zorunlu Alan",
                },
                cruiseDeckName: {
                    required: "Zorunlu Alan",
                },
                cruiseDeckOrder: {
                    required: "Zorunlu Alan",
                },
                cruiseDeckImage: {
                    required: "Zorunlu Alan",
                },
                roomMaxGuestCount: {
                    required: "Zorunlu Alan",
                },
                roomMaxAdultCount: {
                    required: "Zorunlu Alan",
                },
                roomSpace: {
                    required: "Zorunlu Alan",
                },
            },
            errorPlacement: function(error, element) {
                // element.parent().parent().parent().removeClass("error");
                // element.parent().children("small").remove();
                // if ($(element).hasClass('error')) {
                //     element.parent().addClass("error");
                //     element.parent().append('<small class="error-text">'+error.html()+'</small>')
                // }else{
                //     $(element).removeClass("error")
                // }
            },
            success: function(error,element) {
                // $(element).removeClass("error")
                // $(element).parent().removeClass("error");
                // $(element).parent().children("small").remove();
                // console.log("a");
            }
        });

        form.data("validator").settings.ignore = "";
    },
    checkForm : function (formId) {
        let formElement = $("#"+formId);
        if(formElement.length !== 0) {
            if (formElement.validate().checkForm()) {
                if ($('[name ="passwordValidation"]').length == 0) {
                    return true;
                } else if (($('[name ="passwordValidation"]').val() == $('[name ="passwordAgainValidation"]').val())) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }else{
            return true;
        }
    },
    validForm : function (formId) {
        if($("#"+formId).valid()){
            if($('[name ="passwordValidation"]').length == 0){
                return true;
            }else if(($('[name ="passwordValidation"]').val() ==  $('[name ="passwordAgainValidation"]').val())){
                return true;
            }else{
                return false;
            }
        }
        else{
            return false;
        }
    },
    initValidations : function(){
        jQuery.validator.addMethod("passportValidation", function(value,element){
                let passno = element.value;
                //TODO güncel pasaport 7 karakter eskiden 9 karakter regex güncellenmeli
                var ree =/^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/ig;

                if(!ree.test(passno))
                {
                    return false;
                }else{
                    return true;
                }
            });
        jQuery.validator.addMethod("tcvalidation", function(value, element) {
                let tcno = element.value;
                if(element.value == '' ||element.value == undefined) {
                    return true;
                }
                var ree = /^[1-9]{1}[0-9]{10}$/;
                var tcno_val_result = true;

                if(!ree.test(tcno))
                {
                    tcno_val_result = false;
                }
                else
                {
                    let KimlikNo = tcno;
                    if( ! KimlikNo.match(/^[0-9]{11}$/) )
                    {
                        tcno_val_result = false;
                    }

                    let pr1 = parseInt(KimlikNo.substr(0,1));
                    let pr2 = parseInt(KimlikNo.substr(1,1));
                    let pr3 = parseInt(KimlikNo.substr(2,1));
                    let pr4 = parseInt(KimlikNo.substr(3,1));
                    let pr5 = parseInt(KimlikNo.substr(4,1));
                    let pr6 = parseInt(KimlikNo.substr(5,1));
                    let pr7 = parseInt(KimlikNo.substr(6,1));
                    let pr8 = parseInt(KimlikNo.substr(7,1));
                    let pr9 = parseInt(KimlikNo.substr(8,1));
                    let pr10 = parseInt(KimlikNo.substr(9,1));
                    let pr11 = parseInt(KimlikNo.substr(10,1));

                    if( (pr1+pr3+pr5+pr7+pr9+pr2+pr4+pr6+pr8+pr10) % 10 != pr11 ){
                        tcno_val_result = false;
                    }
                    if( ( (pr1+pr3+pr5+pr7+pr9)*7 + (pr2+pr4+pr6+pr8)*9 ) % 10 != pr10 ){
                        tcno_val_result = false;
                    }
                    if( ( (pr1+pr3+pr5+pr7+pr9)*8) % 10 != pr11 ){
                        tcno_val_result = false;
                    }
                }
                return tcno_val_result;
            });
        jQuery.validator.addMethod("birthdate", function(val, element) {
            let type = $(element).attr("passengertype");
            console.log(val);
            if (val != null) {
                var today = moment();
                var birthDate = moment(val);
                var minDate = moment(new Date((today.year() * 1) - (birthdateValidJSON[type].min) * 1 ,today.month() , today.date()));
                var maxDate = moment(new Date((today.year() * 1) - (birthdateValidJSON[type].max) * 1 , today.month() , today.date()));

                if (birthDate > maxDate && minDate > birthDate) {
                    return true;
                }
                return false
            }
            return true;
        });
        jQuery.validator.addMethod("cardyear", function(val, element) {

            if (val != null) {
                var now = new Date();

                var nowYearSplit = now.getFullYear().toString();
                var nowYear = parseInt(nowYearSplit[2]+nowYearSplit[3]);

                var cardYear = val;

                if (cardYear >= nowYear) {
                    return true;
                }
                return false
            }
            return true;
        });
        jQuery.validator.addMethod("cardmonth", function(val, element) {

            if (val != null) {
                var now = new Date();

                var nowYearSplit = now.getFullYear().toString();
                var nowYear = parseInt(nowYearSplit[2]+nowYearSplit[3]);
                var nowMonth = now.getMonth()+1;
                var cardYear = $(element).parent().parent().parent().parent().parent().find("[name='cardYearValidation']").val();
                var cardMonth = val;

                if (cardYear > nowYear) {
                    return true;
                }
                else if(cardYear == nowYear){
                    if (cardMonth>nowMonth || cardMonth==nowMonth){
                        return true;
                    }
                        return false;
                }
                else{
                    return false;
                }

            }
            return true;
        });
        jQuery.validator.addMethod("imageValidate", function (value, element){
            console.log();
            return false;
        });
        jQuery.validator.addMethod("cardowner", function(value,element){
            let owner = element.value;

            var ree =/^([a-zA-ZöğüşöçıİĞÜŞÖÇ]{2,}\s[a-zA-zöğüşöçıİĞÜŞÖÇ]{2,}?)/;

            if(!ree.test(owner))
            {
                return false;
            }else{
                return true;
            }
        });
        $(".datepicker").change(function () {
            $(this).removeClass("error");
            $(this).valid();
        })

        //password popover
        $(function () {
            $('[data-toggle="popover"]').popover()
            $('.popover-dismiss').popover({
                trigger: 'focus'
            })
        })
    }
}